import React from 'react';
import { Badge } from '@mantine/core';
import type { EntityRegistryEntry, ColumnOptions } from '../types';
import { getEmailTemplateWarnings } from '../../validation/emailTemplateValidation';

export const emailTemplateConfig: EntityRegistryEntry = {
    hideIdInStandard: true,
    fetchAttributes: ['Id', 'DisplayName', 'EntityType', 'Subject', 'Description', 'ContentType'],
    listColumns: ({ isStandard }: ColumnOptions) => {
        const columns = [
            {
                key: 'subject',
                label: 'Subject',
                sortable: true,
                render: (entity: any) => {
                    const subj = entity.Subject || '';
                    if (!subj) return 'N/A';
                    return subj.length > 80 ? `${subj.slice(0, 80)}...` : subj;
                }
            },
            {
                key: 'description',
                label: 'Description',
                sortable: true,
                render: (entity: any) => {
                    const desc = entity.Description || '';
                    if (!desc) return '';
                    return desc.length > 60 ? `${desc.slice(0, 60)}...` : desc;
                }
            }
        ];

        if (!isStandard) {
            columns.push({
                key: 'contenttype',
                label: 'Content Type',
                sortable: true,
                render: (entity: any) => {
                    const ct = entity.ContentType || '';
                    if (!ct) return 'N/A';
                    const isHtml = ct.toLowerCase() === 'text/html' || ct.toLowerCase() === 'html';
                    if (!isHtml) {
                        return (
                            <Badge size="sm" variant="light" color="yellow">
                                {ct}
                            </Badge>
                        );
                    }
                    return ct;
                }
            });
        }

        return columns;
    },
    getWarnings: (data) => getEmailTemplateWarnings(data),
};
